import { SOTCreationUpdateDTO, sotFilterDTO } from "./dto";
import { SotServiceImpl } from "./serviceImpl";

export interface SotService {
    CreateSOT(data: SOTCreationUpdateDTO): Promise<void>
    UpdateSOT(data: SOTCreationUpdateDTO, id: string): Promise<void>
    DeleteSOT(id: string): Promise<void>
    RemoveSOT(id: string): Promise<void>
    RestoreSOT(id: string): Promise<void>
    GetHeadQuarter(filters: sotFilterDTO): Promise<any>
    FindSotById(id: string): Promise<any>
}

export function NewSotService(): SotService {
    return new SotServiceImpl();
}
